import security from "common/managers/security";
import securityJquery from "common/managers/securityJquery";
import topic from "common/managers/topic";
import urlapi from "common/managers/urlapi";
import loginProps from "common/managers/loginProps";
import sessionManager from "common/managers/sessionManager";
import locale from "common/managers/locale";
import locking from "common/managers/locking";
import licenseOperations from "common/datasources/license/licenseOperations";
import layout from "app/layout/Layout";
import ConcurrentLogin from "app/login/concurrent/ConcurrentLoginGlue";
import confirmation from "app/main/confirmation/Confirmation";
import Error from "app/main/error/ErrorGlue";
import logoutBase from "app/core/logoutBase";
import userOperations from "common/datasources/user/userOperations";

/**
 * Methods to create if extending this class:
 * - onLaunch: will be called from launch()
 * - initRoute: will be called from route()
 */
export default {
    ...logoutBase,
    launch: function() {
        const launch = () => {
            security.initFromDOM();
            securityJquery.applyCSRF($);
            this.initializeSessionHandling();
            this.initErrorHandlers();

            this.initLogoutHandler();
            // clear any previous mobile flag
            context.mobile = false;

            urlapi.load();
            this.route();
            this.adjustDOM();

            this.onLaunch();
        };
        if(document.readyState === "complete") {
            launch();
        } else {
            window.addEventListener("load", launch);
        }
    },

    initializeSessionHandling: function() {
        sessionManager.start(
            this._sessionValid.bind(this),
            this._sessionTimeoutWarning.bind(this),
            this._sessionExpired.bind(this),
            licenseOperations.sessionKeepAlive,
            licenseOperations.sessionHealth
        );
    },

    initErrorHandlers: function() {
        var server = topic.subscribe("error/server", this.errorServer);
        var malformed = topic.subscribe("error/malformed", $.proxy(this.errorMalformed, this));
        var message = topic.subscribe("error/message", $.proxy(this.errorMessage, this));
        var timeout = topic.subscribe("error/timeout", $.proxy(this.errorTimeout, this));
        var client = topic.subscribe("error/client", $.proxy(this.errorClient, this));
        const authError = topic.subscribe("error/auth", this.forceLogout.bind(this));
        topic.subscribeOnce("app/logoutImminent", function() {
            topic.unsubscribe(server);
            topic.unsubscribe(malformed);
            topic.unsubscribe(message);
            topic.unsubscribe(timeout);
            topic.unsubscribe(client);
            topic.unsubscribe(authError);
        });
    },

    errorServer: function(err) {
        Error.errorServer(err);
    },

    errorMessage: function(err) {
        Error.errorMessage(err);
    },

    errorMalformed: function(err) {
        Error.errorMalformed(err);
    },

    errorTimeout: function() {
        Error.errorTimeout();
    },

    errorClient: function(err) {
        Error.errorClient(err);
    },

    /**
     * Apply the theme to the application
     */
    applyTheme: function() {
        const themeColor = loginProps.get().themeColor || "Palette 1";
        $(document.body).addClass("theme" + themeColor.slice(8));
    },

    adjustDOM() {
        this.applyTheme();
        layout.render();
    },

    /**
     * Abstract
     */
    onLaunch: function() {},

    showView: function(view) {
        layout.showView(view);
    },

    route: function() {
        var me = this;
        this.initRoute();

        topic.subscribe("app/ready", function() {
            $("html").removeClass("loading");
        });
        topic.subscribe("app/loading", function() {
            $("html").addClass("loading");
        });
    },

    /**
     * Abstract
     */
    initRoute: function() {},

    /**
     * Base impl, is usually overridden
     */
    activateModule: function() {
        this.moduleActivated();
    },

    /**
     * Call this when the module has been activated and the view is ready
     */
    moduleActivated: function() {
        this._checkForConcurrentLogins();
    },

    /**
     * Notifies user if other licenses are using the existing user name and allows user to revoke the other licenses
     * @private
     */
    _checkForConcurrentLogins: function() {
        userOperations.hasConcurrent().done((hasConcurrent) => {
            if(hasConcurrent) {
                ConcurrentLogin.open().done(function() {
                    licenseOperations.revokeConcurrentLicenses();
                });
            }
        });
    },

    warnSessionTimeout() {
        return confirmation.caution(locale.get("session.expire.warn"), [{
            id: "sessionTimeoutWarnYes",
            localized: "login.rememberLabel",
            event: "continue"
        }])
    },

    /**
     * Display a warning to the user that allows them to remain logged in
     * @private
     */
    _sessionTimeoutWarning: function() {
        // prevent multiple popups
        if (this._warning) {
            return;
        }
        var me = this;
        sessionManager.pause();
        this._warning = this.warnSessionTimeout().always(function(result) {
            delete me._warning;
            if (!result || result.skipResume !== true) {
                sessionManager.resume();
            }
        });
    },

    /**
     * Called when session manager detects a valid session
     * Responsible for cleaning up the warning popup if it is still active
     * @private
     */
    _sessionValid: function() {
        this._clearWarning();
    },

    /**
     * Clear the warning popup if it is still up
     * @param skipResume {boolean} Whether to resume the session or not, default is to resume the session (false)
     * @private
     */
    _clearWarning: function(skipResume) {
        if (this._warning) {
            var result;
            if (skipResume === true) {
                result = {
                    skipResume: true
                }
            }
            this._warning.reject(result);
            delete this._warning;
        }
    },

    /**
     * Called when the session is expired
     * @private
     */
    _sessionExpired: function() {
        locking.discardLock();
        this.forceLogout();
    }
};
